// extracted by mini-css-extract-plugin
export default {"redmineWidget":"g_PH-ecZuzpVo1Jfz7iNW","bodyHasRedmineWidget":"_1Mf5uiB0mGcoQg0Gnhgco9"};